import { createApp, type App } from 'vue'
import OToaster from '@/components/OToaster'

type ToasterMethod = (...args: any[]) => void

interface OToasterInstance {
  success: ToasterMethod
  info: ToasterMethod
  warning: ToasterMethod
  danger: ToasterMethod
  add: ToasterMethod
  remove: ToasterMethod
  itemClasses: ToasterMethod
}

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    const root = document.createElement('div')
    root.id = 'ota-toaster-root'
    document.body.appendChild(root)

    const toasterApp: App = createApp(OToaster)
    const toasterInstance = toasterApp.mount('#ota-toaster-root') as unknown as OToasterInstance

    // Provide the toaster instance to the main app
    nuxtApp.provide('otoaster', toasterInstance)

    // Expose as this.$otoaster for Options API components/mixins
    const globalProperties = nuxtApp.vueApp.config.globalProperties as typeof nuxtApp.vueApp.config.globalProperties & {
      $otoaster?: OToasterInstance
    }

    if (!globalProperties.$otoaster) {
      globalProperties.$otoaster = toasterInstance
    }
  } else {
    const toasterInstance: OToasterInstance = {
      success: () => {},
      info: () => {},
      warning: () => {},
      danger: () => {},
      add: () => {},
      remove: () => {},
      itemClasses: () => {}
    }

    // Provide the toaster instance to the main app
    nuxtApp.provide('otoaster', toasterInstance)

    // Expose as this.$otoaster for Options API components/mixins
    const globalProperties = nuxtApp.vueApp.config.globalProperties as typeof nuxtApp.vueApp.config.globalProperties & {
      $otoaster?: OToasterInstance
    }

    if (!globalProperties.$otoaster) {
      globalProperties.$otoaster = toasterInstance
    }
  }
})
